import React                    from 'react';
import PropTypes                from 'prop-types';
import {TileDisplayConfigType}  from "../Grid2";
import ReloadHelper             from "../../../utils/ReloadHelper";
import PictureBoxes             from '../../TileGrid/PictureBoxes';
import Flux                     from '../../../flux/Flux';
import DildocontrolOverlay      from '../../TileGrid/DildocontrolOverlay';
import ActorPlateLight          from '../../TileGrid/ActorPlateLight';
import ActorPlate               from "./ActorPlate";
import ActorPlateExtended       from "./ActorPlateExtended";
import VideoStarPlate           from "../../TileGrid/VideoStarPlate";
import Translations             from "../../../utils/Translations";
import TileBadgeHD              from '../../TileGrid/Badge/TileBadgeHD';
import TileBadgeLivePreview     from '../../TileGrid/Badge/TileBadgeLivePreview';
import TileBadgeLive            from '../../TileGrid/Badge/TileBadgeLive';
import ActorBirthdayPlate       from '../../TileGrid/ActorBirthdayPlate';
import ActorContactContainer    from '../../TileGrid/Tile/ActorContactContainer';
import { getCommonTranslation } from '../../../utils/TranslationHelper';
import TopAmateurRibbon         from './TopAmateurRibbon';
import { generateKey } 			from '../../../utils/CommonUtils';

const ActorTile = props => {
	let data        = props.data;
	const isBigTile = props.displayConfig.tileSize.values.xs > 1;
	if (typeof props.data.model !== 'undefined') {
		data = props.data.model;
	}
	let additionalImageClassName = '';

	const preview         = {
		title:       data.name,

	};
	const linkUrl         = data.linkVX;
	const onClick         = e => {
		ReloadHelper.reload(linkUrl, e);
	};
	const onClickCallback = (e) => {
		e.preventDefault();
		data.callback(data);
	};

	if ((props.data.model || isBigTile) && data.sedcard.length > 1) {
		additionalImageClassName = ' -animation-start';
	}

	const pictures = [];
	if (data.sedcard.length > 0) {
		data.sedcard.map((sedcard) => {
			pictures.push([{
				format:     'w0',
				height:     0,
				id:         sedcard.id,
				isPortrait: false,
				src:        sedcard.url,
				width:      0,
			}]);
		});
	}

	if (pictures.length === 0) {
		pictures.push(
			[{
				format:     'w0',
				height:     0,
				id:         1,
				isPortrait: true,
				src:        data.avatar.url,
				width:      0,
			}]
		);
	}

	if (pictures.length === 1) {
		additionalImageClassName += ' -no-animation';
	}

	const pictureBoxes = <PictureBoxes pictures={pictures}
	                                   useIndexForClassName={true}
	                                   outerClassName={'actor-image' + additionalImageClassName}
	                                   usePlaceholder={true}
	                                   setMaxWidth={false}
									   containerClassName="h-height-0"
	/>;

	const badges = [];
	if (data.chat.online) {
		badges.push(<TileBadgeLive key={generateKey('tile-live', badges.length)} className="badge--normal" show={data.chat.online}/>);
	}

	if (data.chat.features) {
		if (data.chat.features.hd) {
			badges.push(<TileBadgeHD key={generateKey('tile-hd', badges.length)} show={data.chat.features.hd}/>);
		}

		if (data.chat.features.livePreview) {
			badges.push(<TileBadgeLivePreview key={generateKey('tile-preview', badges.length)} show={data.chat.features.livePreview}/>);
		}
	}

	if (props.config.plate !== VideoStarPlate && data.newVideoCount) {
		const text = data.newVideoCount + " " + (data.newVideoCount === 1 ? Translations.get('ActorProfileNewVideo') : Translations.get('VideoGridNewestTitle'));
		badges.push(<span key={generateKey('new-video', badges.length)} className={'badge -newVideoCount'}>{text}</span>);
	}

	let badge = null;
	if (badges.length > 0) {
		badge = (
			<span className="badge-container" style={{zIndex: 204}}>
				{badges}
			</span>
		);
	}

	let plate;
	switch (props.config.plate) {
		case ActorPlate:
			plate = <ActorPlate showSpokenLanguages={false}
			                    spokenLanguages={null}
			                    name={preview.title}
			                    age={data.profile.age}
			                    totalVideosCount={data.videoCount}
			                    hideAge={props.config.hideAge}
			                    headlineType={props.headlineType}
			/>;
			break;
		case ActorBirthdayPlate:
			plate = <ActorBirthdayPlate
				name={data.name}
				age={data.profile.age}
				birthdayText={data.birthdayText}/>;
			break;
		case ActorPlateLight:
			plate = <ActorPlateLight name={preview.title} age={data.profile.age}/>;
			break;
		case VideoStarPlate:
			plate =
				<VideoStarPlate actorAge={data.profile.age}
				                actorName={data.name}
				                videosCount={data.videoCount}
				                newVideosCount={data.newVideoCount}/>;
			break;
		default:
			plate = <ActorPlate name={data.name}
			                    age={data.profile.age}
			                    spokenLanguages={data.profile.languages}
			                    showSpokenLanguages={true}
			/>;
	}

	let container;
	switch (props.config.container) {
		case ActorContactContainer:
			container = (
				<ActorContactContainer
					show					= {true}
					openMessenger			= {() => {}}
					multiChatPrice		    = {data.chat.prices.videoChat.value}
					singleC2CChatPrice	    = {data.chat.prices.singleC2CChat.value}
					hasLivePreview  		= {data.chat.features.livePreview}
					isFavorite		    	= {Boolean(props.data.modelGuestRelation && props.data.modelGuestRelation.isFavorite)}
					actorId				    = {data.id}
					isOnline			    = {data.online}
					isGuestLoggedIn		    = {Flux.Guest.isLoggedIn()}
					sublineText			    = {data.registeredSince < 2
												? getCommonTranslation('new-actors-grid-tile-subline')
												: getCommonTranslation('new-actors-grid-tile-subline--days', data.registeredSince)
											}
					isActorPinned		    = {false}
					isOnlineMobileVideocall = {data.isOnlineMobileVideocall}
				/>
			);
			break;
	}

	let additionalClass = '';
	if (props.config.isNewGirlStyle) {
		additionalClass = "is-newly-registered";
	}

	let surroundingClass = "";
	if (isBigTile) {
		surroundingClass = "is-highlight-actor-tile" + (props.data.isTopAmateur ? " is-top-amateur" : "");
		plate = <ActorPlateExtended
					actorId={data.id}
					name={data.name}
					age={data.profile.age}
					isOnline={data.online}
					spokenLanguages={data.profile.languages}
					multiChatPrice={data.chat.prices.videoChat.value}
                    singleC2CChatPrice={data.chat.prices.singleC2CChat.value}
					guestIsLoggedIn={Flux.Guest.isLoggedIn()}
					isModelGuestFavorite={Boolean(props.data.modelGuestRelation && props.data.modelGuestRelation.isFavorite)}
					isMobile={props.isMobile}
					isTopAmateur={props.data.isTopAmateur}
					gaString="Top-Amateur"
					isOnlineMobileVideocall={data.isOnlineMobileVideocall}
				/>;
	}

	return (
		<div className={surroundingClass}>
			<a href={linkUrl} onClick={data.callback ? onClickCallback : onClick} className={"link -color-standard-white h-disp-block actor-tile " + additionalClass}>
				<div>
					{isBigTile && <TopAmateurRibbon show={props.data.isTopAmateur} />}
					{pictureBoxes}
					{badge}
					{data.chat.features.dildocontrol && data.chat.online && (!Flux.Guest.isLoggedIn() || Flux.Guest.hasAvs()) &&
						<DildocontrolOverlay isLarge={isBigTile}/>}
					{container}
				</div>
				{plate}
			</a>
		</div>
	);
};

ActorTile.propTypes = {
	data:          PropTypes.object.isRequired, // VXQL Mediathek type
	config:        PropTypes.shape({
		plate:          PropTypes.func,
		container:      PropTypes.func,
		hideAge:        PropTypes.bool,
		isNewGirlStyle: PropTypes.bool,
	}).isRequired,
	displayConfig: TileDisplayConfigType.isRequired,
	headlineType:  PropTypes.string,
	isMobile:      PropTypes.bool
};

ActorTile.defaultProps = {
	isMobile: false,
};

export default ActorTile;
